import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconCase$1 = /*@__PURE__*/ proxyCustomElement(class WppIconCase extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-case", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M13.4949 3.25007C13.8102 3.25448 14.0891 3.45572 14.1928 3.75361L17.8449 14.2536C17.981 14.6448 17.7742 15.0723 17.383 15.2084C16.9917 15.3445 16.5643 15.1376 16.4282 14.7464L15.6468 12.5L11.0613 12.5L10.2014 14.7661C10.0545 15.1533 9.6214 15.3482 9.23413 15.2012C8.84686 15.0543 8.65204 14.6212 8.79899 14.2339L12.7832 3.73393C12.8951 3.43904 13.1795 3.24567 13.4949 3.25007ZM11.6304 11L15.1251 11L13.4537 6.19485L11.6304 11ZM4.90399 8.93701C4.44554 8.95466 4.05452 9.06145 3.83555 9.17094C3.46507 9.35618 3.01456 9.20601 2.82932 8.83553C2.64408 8.46504 2.79425 8.01454 3.16473 7.8293C3.61243 7.60545 4.22141 7.46218 4.8463 7.43812C5.47522 7.41392 6.19242 7.50765 6.83562 7.82933C8.25597 8.53968 8.25173 9.95429 8.25023 10.4565L8.25014 10.5V14.4998C8.25014 14.914 7.91435 15.2498 7.50014 15.2498C7.10489 15.2498 6.78105 14.9441 6.75223 14.5562C5.88084 15.0944 4.86112 15.4068 3.80679 15.1252C1.73001 14.5706 1.00572 11.7613 3.08351 10.3763C3.85798 9.86004 4.78617 9.72415 5.60969 9.76586C5.98888 9.78506 6.36324 9.8426 6.71484 9.928C6.6597 9.61712 6.51947 9.34835 6.16467 9.1709C5.80786 8.99246 5.35839 8.91952 4.90399 8.93701ZM6.75014 11.4993C6.39595 11.3773 5.97105 11.2861 5.53382 11.2639C4.90502 11.2321 4.33273 11.3463 3.91549 11.6244C2.99216 12.2399 3.27012 13.4293 4.19379 13.676C4.9448 13.8765 5.862 13.4926 6.75014 12.6799V11.4993Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-case-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-case", "wpp-icon-case-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-case-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-case-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconCase$1);
      }
      break;
  } });
}

const WppIconCase = WppIconCase$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconCase, defineCustomElement };
